import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Button} from '../button/button';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from '../icon/svg/external-link-icon';
import {GlossaryIcon} from '../icon/svg/glossary-icon';
import {Link} from '../link/link';

import type {CTA} from './promo-state';

export function createCta(cta: CTA, isPrimary: boolean) {
    let ctaIcon;
    if (cta.url && isPrimary) {
        ctaIcon = <ExternalLinkIcon size={13} wrapWithDiv={false} />;
    } else if (cta.onClick && isPrimary) {
        ctaIcon = <GlossaryIcon size={13} wrapWithDiv={false} />;
    }

    const ctaText = (
        <div className='flex flex-dir-row gap-8 align-center'>
            {ctaIcon}
            <div>{cta.text}</div>
        </div>
    );

    let ctaLink;
    if (cta.url && !cta.isExternalLink) {
        ctaLink = (
            <Link
                // @ts-expect-error
                as={RoutedLink}
                to={cta.url}
                variant={isPrimary ? 'primary' : 'button'}
                size='big'
            >
                {ctaText}
            </Link>
        );
    } else if (cta.url && cta.isExternalLink) {
        ctaLink = (
            <Link
                href={cta.url}
                newTab={true}
                variant={isPrimary ? 'primary' : 'button'}
                size='normal'
            >
                {ctaText}
            </Link>
        );
    } else if (cta.onClick) {
        ctaLink = (
            <Button
                onClick={cta.onClick}
                variant={isPrimary ? 'text-primary' : 'primary'}
                size='big'
                fitContent={true}
                noPadding={isPrimary}
            >
                {ctaText}
            </Button>
        );
    }

    return ctaLink;
}
